import { type CurrencyType } from 'src/types/currency';

export interface DataSetRecord {
  tabbyCurrency: CurrencyType;
  tabbyPrice: number;
  tabbyInstallmentsCount: number;
  tabbyLanguage?: string;
  tabbyLocale?: string;
}

export const getDataFromDataset = (dataset: DOMStringMap): DataSetRecord => {
  return Object.keys(dataset || {}).reduce((acc, key) => {
    return { ...acc, [key]: dataset[key] };
  }, {} as DataSetRecord);
};
